import Http from '@/utils/http/index';
export default {
  /**
   * 应用列表
   */
  getApplicationList(params) {
    return Http.get('/merchant/app/applist', { params });
  },

  /**
   * 应用详情
   */
  getApplicationDetails(params) {
    return Http.get('/merchant/app/getUserAppInfo', { params });
  },
  /**
   * 添加应用
   */
  postAddApplication(params) {
    return Http.post('/merchant/app/add', params);
  },
  /**
   * 修改应用
   */
  postEditApplication(params) {
    return Http.post('/merchant/app/edit', params);
  },
  /**
   * 下载应用
   */
  downloadApplicationList(params) {
    return Http.get('/app/download', { params });
  },
  /**
   * 支持卡种
   */
  getSupoortCards(appId) {
    return Http.get(`/app/supportCard/${appId}`);
  },
};
